import { Link } from 'react-router-dom';
import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';

const Paginations = ({
	perPageData,
	dataLength,
	currentPage,
	setCurrentPage,
	isShowingPageLength,
	paginationDiv,
	paginationClass,
	totalPage = 0
}) => {
	const totalPages = totalPage > 0 ? totalPage : Math.ceil(dataLength / perPageData);

	const handleClick = pageNumber => {
		setCurrentPage(pageNumber);
	};

	const handlePrevPage = () => {
		if (currentPage > 1) {
			setCurrentPage(currentPage - 1);
		}
	};

	const handleNextPage = () => {
		if (currentPage < totalPages) {
			setCurrentPage(currentPage + 1);
		}
	};

	useEffect(() => {
		if (totalPages && totalPages < currentPage) {
			setCurrentPage(totalPages);
		}
	}, [totalPages, currentPage, setCurrentPage]);

	// Generate the list of page numbers to display
	const getPageNumbers = () => {
		const pageNumbers = [];

		// Always show the first page
		if (totalPages > 0) {
			pageNumbers.push(1);
		}

		// Add ellipsis if needed
		if (currentPage > 3) {
			pageNumbers.push('...');
		}

		// Show two pages before and after the current page
		for (let i = currentPage - 3; i <= currentPage + 3; i++) {
			if (i > 1 && i < totalPages) {
				pageNumbers.push(i);
			}
		}

		// Add ellipsis if needed
		if (currentPage < totalPages - 3) {
			pageNumbers.push('...');
		}

		// Always show the last page
		if (totalPages > 1) {
			pageNumbers.push(totalPages);
		}

		return pageNumbers;
	};

	const pageNumbers = getPageNumbers();

	return (
		<React.Fragment>
			<Row className="justify-content-between align-items-center">
				{isShowingPageLength && (
					<Col sm={12} md={5}>
						<div className="text-muted dataTables_info">
							Showing {Math.min(perPageData, dataLength - (currentPage - 1) * perPageData)} of {dataLength} entries
						</div>
					</Col>
				)}
				<div className={paginationDiv}>
					<ul className={paginationClass}>
						{/* Previous button */}
						<li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
							<Link className="page-link" to="#" onClick={handlePrevPage}>
								<i className="mdi mdi-chevron-left"></i>
							</Link>
						</li>

						{/* Page number buttons */}
						{pageNumbers.map((item, index) =>
							item === '...' ? (
								<li className="page-item disabled" key={index}>
									<span className="page-link">...</span>
								</li>
							) : (
								<li className={currentPage === item ? 'page-item active' : 'page-item'} key={index}>
									<Link className="page-link" to="#" onClick={() => handleClick(item)}>
										{item}
									</Link>
								</li>
							)
						)}

						{/* Next button */}
						<li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
							<Link className="page-link" to="#" onClick={handleNextPage}>
								<i className="mdi mdi-chevron-right"></i>
							</Link>
						</li>
					</ul>
				</div>
			</Row>
		</React.Fragment>
	);
};

export default Paginations;
